import { StoryblokTabbedContentSection } from './StoryblokTabbedContentSection'

import { createTabbedContentSection } from './__mocks__/tabbedContentSection'

export { createTabbedContentSection }

// Re-export for backward compatibility
export const dummyTabbedContentSectionBlok = createTabbedContentSection()

export default StoryblokTabbedContentSection
